// extracted by mini-css-extract-plugin
export default {"userPanel":"userPanel___br3lb","userPanelHeader":"userPanelHeader___djvDx","userPanelMenu":"userPanelMenu___Wdm26","avatar":"avatar___OX0fJ"};